module.exports = __webpack_public_path__ + "files/e08fb35ad67a931179999c6574728056.png";